<div class="titleBox"> <h1 style="text-align: center">Customer Jobs</h1></div>
<div><hr></div>
<br>
<br>
<div style="margin-top: 20px; display: flex; justify-content: end;">
  <span><label>Hide Inactive Jobs</label></span>
  <label class="switch">
    <input type="checkbox" [checked]="activeJobToggle" (click)='filterActiveJobs()' >
    <span class="slider round"></span>
  </label>
  </div>
<button mat-raised-button (click)="add()">Add New Customer Job<fa-icon></fa-icon></button>
      <ngx-table [configuration] = "configuration"  [data]="filterActiveJob$ | async" [columns]="columns" [loadingTemplate] = "loadingTemplate">
          <ng-template let-row >
            <td>
              <div>
                  <button button mat-raised-button color="green" (click)="openDialog(row)">
                    <fa-icon [icon]="faedit"></fa-icon>
                  </button>
              </div>

              <div>
                  <button mat-button color="warn" title="Make Inactive" (click)="delete(row)">
                    <fa-icon [icon]="fadeactivate"></fa-icon>
                  </button>
              </div>

              <div>
                <button mat-button color="black" title="Copy Customer Job Type" (click)="copy(row)">
                  <fa-icon [icon]="facopy"></fa-icon>
                </button>
              </div>

            </td>

            <td>
              <div>
                {{row.customer_name}} {{row.subdivision > 0 ? '-' + row.subdivision_name : ''}}
              </div>
            </td>

            <td [style]='row.inactivecustomerjob ? "background-color: #ffc4c4 ;": "background-color:white;" '>
                <div>
                  {{row.job_type_name}}
                </div>
            </td>

            <td>
                <div>
                  <span *ngIf="row.inactivecustomerjob"><p style="color:red; font-style: italic;"> Inactive</p> </span>
                  {{row.note}}
                </div>
            </td>

          </ng-template>
        </ngx-table>






<ng-template #loadingTemplate>
  <td [attr.colspan]="columns.length">
    <div style= "width: 100%; text-align: center">
      <div style="display: inline-block; margin: auto; padding: 3px">
          <div class="lds-ripple"><div></div><div></div>Loading...</div>
      </div>
    </div>
  </td>
</ng-template>
